import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VariavelVisualizacao = _resolveComponent("VariavelVisualizacao")!
  const _component_VariavelEdicao = _resolveComponent("VariavelEdicao")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.variavel.getEmEdicao())
      ? (_openBlock(), _createBlock(_component_VariavelVisualizacao, {
          key: 0,
          variavel: _ctx.variavel,
          ehPrimeiro: _ctx.ehPrimeiro,
          ehUltimo: _ctx.ehUltimo,
          onEditar: _ctx.editar,
          onExcluir: _ctx.excluir,
          onDescer: _ctx.descer,
          onSubir: _ctx.subir
        }, null, 8, ["variavel", "ehPrimeiro", "ehUltimo", "onEditar", "onExcluir", "onDescer", "onSubir"]))
      : _createCommentVNode("", true),
    (_ctx.variavel.getEmEdicao())
      ? (_openBlock(), _createBlock(_component_VariavelEdicao, {
          key: 1,
          variavel: (_ctx.variavel as VariavelEditavel)
        }, null, 8, ["variavel"]))
      : _createCommentVNode("", true)
  ]))
}